import { instance } from '../../config/intercepter';

export const getKycInfo = async (payload) => {
    const response = await instance.get(`api/orders/${payload.cncode}/kyc/callback?code=${payload.code}`);
    return response.data;
};

export const saveKYCCustomerForm = async (payload) => {
    const response = await instance.post(`api/orders/${payload.cncode}/kyc/savecustomerform`, payload.data);
    return response.data;
}